import { defineMessages } from 'react-intl';

export default defineMessages({
    priceCheckMessage: {
        id: '_.price_check_banner.message',
        defaultMessage:
            'Have a better offer from elsewhere? <strong>We now price check.</strong>'
    },
    priceCheckCTA: {
        id: '_.price_check_banner.cta',
        defaultMessage: 'Learn more'
    },
    modalTitle: {
        id: '_.price_check_banner.modal.title',
        defaultMessage: 'Price check invitation'
    },
    modalSubtitle: {
        id: '_.price_check_banner.modal.subtitle',
        defaultMessage:
            'Have a better offer from elsewhere? We would be happy to support your business and offer to review the offer you have received for a reassessment.'
    }
});
